const telemetryFlag = import.meta.env.VITE_ENABLE_TELEMETRY

export const TELEMETRY_ENABLED = telemetryFlag === 'true'

// The commit SHA of the deployed build, so every event can be traced to the exact release.
// package.json has no real version and the release tag is only computed after the build.
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'local'
